// The first result of Apple's reverse geocoder, flattened the way the address pages use it: its fields plus those of
// its structuredAddress, and formattedAddress, its lines without "United States", one per line. Shared by the
// browser's lookups (useMapkit) and the server's (server/utils/appleMaps.js), so both have the same shape.
export function formatReverseGeocodeResult(response) {
  const { structuredAddress, ...address } = response?.results?.[0] ?? {};
  const formattedAddress = address.formattedAddressLines?.filter((line) => line != "United States")?.join("\n");
  return { ...address, ...structuredAddress, formattedAddress };
}
